module.exports = __webpack_public_path__ + "9e0957f9b2bfe36b04f75cb440cb56d5.fbx";